import { render, staticRenderFns } from "./QuillWrapper.vue?vue&type=template&id=5426991d&"
import script from "./QuillWrapper.vue?vue&type=script&lang=js&"
export * from "./QuillWrapper.vue?vue&type=script&lang=js&"
import style0 from "./QuillWrapper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports